export const elementKeyPressHandler = (e, callBack, data, triggerKeys) => {
    const allowedKeys = triggerKeys || [
        'ArrowUp',
        'ArrowDown',
        'ArrowLeft',
        'ArrowRight',
        'Enter',
    ];
    if (allowedKeys.includes(e.key)) {
        const keyPressed = allowedKeys.filter((key) => key === e.key).toString() || '';
        callBack(keyPressed, data, e);
        e.preventDefault();
    }
};
//# sourceMappingURL=autocomplete.utils.js.map